<script>
    /**
     * A series of buttons populated like a listbox.
     */
    export default {
        name: 'ib-button-list',

        props: {
            data: Array,
            /**
             * Value of currently selected entry, typically applied with `v-model`.
             */
            value: {
                type: [String, Number, Boolean, Array],
                default: undefined
            },
            /**
             * Member of data entry to emit as value. May be specified as a function.
             * By default, for object entries we emit the `value` member and for non-object entries we emit the entry.
             */
            emit: {
                type: [String, Number, Function],
                default: 'value'
            }
        },

        computed: {
            getval() {
                const emit = this.emit;
                return typeof emit === 'function'
                    ? emit
                    : o => typeof o === 'object' ? o[emit] : o;
            }
        },

        render(h) {
            return h('div', {}, this.data.map(e => {
                const id = this.getval(e);
                return h('ib-button', {
                    'key': id,
                    'attrs': {
                        'tone': id == this.value ? 'accent' : null,
                    },
                    'on': {
                        'click': () => { this.$emit('input', id); }
                    },
                }, [
                    this._t('default', [ e.label ], null, e)
                ]);
            }));
        }
    }
</script>
